module.exports = __webpack_public_path__ + "static/fonts/YouSheBiaoTiHei.1726685c.ttf";